import Fade from "@mui/material/Fade";

import borders from "../base/borders";
import colors from "../base/colors";
import typography from "../base/typography";

import pxToRem from "../functions/pxToRem";

const { black, light } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

const tooltip = {
  defaultProps: {
    arrow: true,
    TransitionComponent: Fade,
  },

  styleOverrides: {
    tooltip: {
      backgroundColor: black.main,
      color: light.main,
      fontSize: size.sm,
      fontWeight: fontWeightRegular,
      borderRadius: borderRadius.sm,
      opacity: 0.7,
      padding: pxToRem(8),
    },

    arrow: {
      color: black.main,
    },
  },
};

export default tooltip;
